import React from 'react';
import { X } from 'react-feather';
import { Logo } from './Logo';
import { NavItem } from './NavItem';
export function MobileMenu({
  isOpen,
  onClose,
  activePage,
  onNavigate
}: {
  isOpen: boolean;
  onClose: () => void;
  activePage: string;
  onNavigate: (page: string) => void;
}) {
  return <div className={`fixed inset-0 bg-[#111111] z-50 transition-opacity duration-700 ease-in-out
        ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-153">
      <div className="flex flex-col h-full" data-id="element-154">
        <div className="h-[80px] flex items-center justify-between px-8" data-id="element-155">
          <Logo onClick={() => {
          onNavigate('home');
          onClose();
        }} data-id="element-156" />
          <button onClick={onClose} className="p-2 rounded-full hover:bg-white text-white hover:text-[#111111] transition-all duration-300 transform hover:scale-105" aria-label="Close menu" data-id="element-157">
            <X size={24} strokeWidth={2} data-id="element-158" />
          </button>
        </div>
        <nav className="flex-1 py-12 px-8" aria-label="Site navigation" data-id="element-159">
          <div className="space-y-8" data-id="element-160">
            <section aria-labelledby="mobile-focus-heading" data-id="element-161">
              <p id="mobile-focus-heading" className="mb-3 text-[1.1rem] text-[#7A8290] md:text-fluid-lg md:text-[clamp(1.333rem,2vw,1.777rem)]" data-id="element-162">
                My focus:
              </p>
              <ul className="flex flex-col items-start space-y-6" data-id="element-163">
                <li className="w-full" data-id="element-164">
                  <NavItem label="The problem behind the problem" isActive={activePage === 'complexity'} onClick={() => {
                  onNavigate('complexity');
                  onClose();
                }} isMobile data-id="element-165" />
                </li>
                <li className="w-full" data-id="element-166">
                  <NavItem label="Turning research into decisions" isActive={activePage === 'research'} onClick={() => {
                  onNavigate('research');
                  onClose();
                }} isMobile data-id="element-167" />
                </li>
                <li className="w-full" data-id="element-168">
                  <NavItem label="Building systems that last" isActive={activePage === 'systems'} onClick={() => {
                  onNavigate('systems');
                  onClose();
                }} isMobile data-id="element-169" />
                </li>
              </ul>
            </section>

            <section aria-labelledby="mobile-case-studies-heading" data-id="element-170">
              <p id="mobile-case-studies-heading" className="mb-3 text-[1.1rem] text-[#7A8290] md:text-fluid-lg md:text-[clamp(1.333rem,2vw,1.777rem)]" data-id="element-171">
                My work:
              </p>
              <ul className="flex flex-col items-start" data-id="element-172">
                <li className="w-full" data-id="element-173">
                  <NavItem label="Turning rules into a workflow brokers can clear" isActive={activePage === 'work/required-actions'} onClick={() => {
                  onNavigate('work/required-actions?from=work');
                  onClose();
                }} isMobile data-id="element-174" />
                </li>
              </ul>
            </section>
          </div>
        </nav>
        <div className="px-8 py-6 flex justify-between items-center" data-id="element-175">
          <p className="text-fluid-sm text-[#7A8290]" data-id="element-176">© All rights reserved</p>
          <a href="https://www.linkedin.com/in/mintextract/" target="_blank" rel="noopener noreferrer" className="text-fluid-sm text-[#7A8290] hover:text-white transition-colors duration-300" data-id="element-177">
            LinkedIn
          </a>
        </div>
      </div>
    </div>;
}